import { from } from "rxjs";
import { switchMap, take } from "rxjs/operators";
import { selectBuildingInfoByTypeId } from "../../../selectors/selectExistingBuildingInfo";
import { selectActiveTutorialConfig } from "../../../selectors/selectTutorial";
import { utilBuildings } from "../../../utils/utilBuildings";
import { actionViewportCenterOn, actionViewportClearCenter } from "../../viewport/actionViewport";
import { actionTutorialSelect } from "../actionTutorial";
export var pathTutorialUpdateViewport = function (action, state$, deps) {
    return deps.inStoreDependencies.viewportChanged$.pipe(take(1), switchMap(function (viewport) {
        var state = state$.value;
        var tutorialConfig = selectActiveTutorialConfig(state);
        var building = selectBuildingInfoByTypeId(state, tutorialConfig.buildingId);
        var origin = utilBuildings.getCenterPositionOnScreen(building, viewport);
        return from([
            actionViewportClearCenter(),
            actionTutorialSelect(tutorialConfig.nextStep),
            actionViewportCenterOn(origin),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/path/pathTutorialUpdateViewport.ts
// module id = 359
// module chunks = 3